export const getEvidenceReferenceId = (item = {}) => `${item.sourceType}:${item.sourceId}`;

export const resolvePreparationReferences = (sourceIds = [], evidence = []) => {
  const byId = new Map(evidence.map((item) => [getEvidenceReferenceId(item), item]));
  return sourceIds.map((id) => byId.get(id)).filter(Boolean);
};
